import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { authService } from '../services/api';
import NavBar from '../components/NavBar';

const VerifyEmailPage: React.FC = () => {
  const { user, refresh } = useAuth();
  const [code, setCode] = useState('');
  const [status, setStatus] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (!success) return;
    const interval = setInterval(() => {
      setCountdown(n => {
        if (n <= 1) {
          clearInterval(interval);
          window.location.href = '/dashboard';
        }
        return n - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [success]);

  const sendCode = async () => {
    try {
      const data = await authService.sendVerification();
      const extra = data?.code ? ` | Código: ${data.code}` : '';
      setStatus('Código enviado para ' + (user?.email || 'seu email') + extra);
    } catch (e: any) {
      setStatus(e?.response?.data?.detail || 'Falha ao enviar código');
    }
  };

  const verify = async () => {
    try {
      await authService.verifyCode(code.trim());
      await refresh();
      setSuccess(true);
    } catch (e: any) {
      setStatus(e?.response?.data?.detail || 'Código inválido');
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-mystical flex items-center justify-center px-6">
        <div className="max-w-md w-full bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 text-center">
          <div className="text-6xl mb-4">✨</div>
          <h1 className="text-2xl font-mystical font-bold text-white mb-2">Email verificado!</h1>
          <p className="text-gray-300 mb-6">Bem-vindo ao Astralyz.</p>
          <div
            className="rounded-xl p-4 mb-6"
            style={{ background: 'linear-gradient(135deg, rgba(245,158,11,0.2), rgba(139,92,246,0.2))', border: '1px solid rgba(245,158,11,0.4)' }}
          >
            <p className="text-amber-300 font-bold text-lg">🎁 3 tokens de boas-vindas</p>
            <p className="text-white/70 text-sm mt-1">Já estão na sua conta. Faça sua primeira leitura!</p>
          </div>
          <p className="text-white/40 text-sm">Redirecionando em {countdown}s…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-mystical">
      <NavBar />
      <div className="max-w-md mx-auto px-6 py-12">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
          <h1 className="text-2xl font-mystical font-bold text-white mb-4">Verificação de Email</h1>
          <p className="text-gray-300 mb-4">Digite o código numérico enviado para {user?.email}.</p>
          <div className="space-y-3">
            <input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="w-full px-4 py-3 bg-black/30 border border-white/20 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-gold-400"
              placeholder="Código de 6 dígitos"
            />
            <div className="flex gap-2">
              <button onClick={sendCode} className="px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white">Enviar Código</button>
              <button onClick={verify} className="px-4 py-2 bg-mystical-500 text-white rounded-xl">Validar Código</button>
            </div>
            {status && <div className="text-sm text-gray-300 mt-2">{status}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
